import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, InputLabel, MenuItem, Modal, Select, Tab, Tabs, TextField } from '@mui/material';
import { LocalizationProvider, TimeField } from '@mui/x-date-pickers';
import React, { useEffect, useState } from 'react'
import RouteModal from '../routeModal';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import ConfirmModal from '../confirmModal';
import { mixedNaturalSort, TabPanel } from '../../utils/generalFunctions';
import MultiSchedulesModal from '../multiSchedulesModal';

const EditSchedulesAdmin = ({ showedLayout, onClose, schedules = [], allSchedules, userUpdate, onSave, showAlert, usersData, scheduleRegister, updateSchedule, setShowedLayout }) => {

  const [currentScheduleIndex, setCurrentScheduleIndex] = useState(0);
  const [currentSchedule, setCurrentSchedule] = useState(schedules[0] || {});

  const [currentUser, setCurrentUser] = useState(usersData.find(user => user.userId === currentSchedule.userId));

  const [errorMessage, setErrorMessage] = useState("");

  const [openRouteModal, setOpenRouteModal] = useState(false);

  const [scheduleName, setScheduleName] = useState("");
  const [vehicle, setVehicle] = useState("Ninguno");
  const [controlPointStart, setControlPointStart] = useState("");
  const [controlPointEnd, setControlPointEnd] = useState("");
  const [timeDifference, setTimeDifference] = useState({ minutes: 5, seconds: 0 });
  const [lastGeneratedTimeDifference, setLastGeneratedTimeDifference] = useState(null);
  const [numLaps, setNumLaps] = useState(10);
  const [tableData, setTableData] = useState([]);
  const [routeOrder, setRouteOrder] = useState(currentSchedule?.turns[0].map(cp => cp.label) || []);
  const [startTime, setStartTime] = useState(dayjs().hour(12).minute(0).second(0)); // Nueva hora de inicio con dayjs
  const [customTimeDifferences, setCustomTimeDifferences] = useState(
    routeOrder.filter(geofence => geofence.state === 'activo').map(() => ({ ...timeDifference }))
  );

  const [scheduleNameError, setScheduleNameError] = useState(false);

  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [pendingVehicleChange, setPendingVehicleChange] = useState(null);

  const userSchedules = allSchedules.filter(schedule => schedule.userId === currentUser.userId)
  const devices = currentUser?.vehicles || [];
  const geofences = currentUser?.route || [];
  const [userRoute, setUserRoute] = useState(currentUser?.route || []);

  const [multiScheduleCount, setMultiScheduleCount] = useState(2);
  const [multiScheduleModalOpen, setMultiScheduleModalOpen] = useState(false);


  const [tabIndex, setTabIndex] = useState(0);

  const [selectedScheduleBulk, setSelectedScheduleBulk] = useState(schedules[0] || []);
  const [controlPointStartBulk, setControlPointStartBulk] = useState("");
  const [controlPointEndBulk, setControlPointEndBulk] = useState("");
  const [numLapsBulk, setNumLapsBulk] = useState(10);
  const [timeDifferenceBulk, setTimeDifferenceBulk] = useState({ minutes: 1, seconds: 0 });
  const [tableDataBulk, setTableDataBulk] = useState([]);
  const [routeOrderBulk, setRouteOrderBulk] = useState(selectedScheduleBulk?.turns[0].map(cp => cp.label) || []);
  const [customTimeDifferencesBulk, setCustomTimeDifferencesBulk] = useState(
    routeOrderBulk.filter(geofence => geofence.state === 'activo').map(() => ({ ...timeDifferenceBulk }))
  );

  const [originalBulkValues, setOriginalBulkValues] = useState({
    controlPointStartBulk: "",
    controlPointEndBulk: "",
    timeDifferenceBulk: { minutes: 1, seconds: 0 },
    numLapsBulk: 10,
  });

  const [lastGeneratedTimeDifferenceBulk, setLastGeneratedTimeDifferenceBulk] = useState({ minutes: 1, seconds: 0 });

  const [bulkConfirmOpen, setBulkConfirmOpen] = useState(false);
  const [bulkDiff, setBulkDiff] = useState([]);


  const handleTabChange = (event, newIndex) => {
    setTabIndex(newIndex);
  };

  const formatTime = (time) => {
    if (time === null || time === undefined) return ""; // Mostrar cadena vacía si el tiempo es null
    const hours = Math.floor(time / 3600);
    const minutes = Math.floor((time % 3600) / 60);
    const seconds = time % 60;
    return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  };

  useEffect(() => {
    if (!schedules || schedules.length === 0) return;

    setCurrentScheduleIndex(0);

    const first = schedules[0];

    setCurrentSchedule(first);
    setCurrentUser(usersData.find(user => user.userId === first.userId));
    setScheduleNameError(false);

    setSelectedScheduleBulk(first);

    if (showedLayout === 2) {
      fillData();
      fillDataBulk();
    }

  }, [showedLayout]);

  useEffect(() => {
    if (schedules.length > 0 && selectedScheduleBulk?.turns) {
      const route = selectedScheduleBulk.turns[0].map(cp => cp.label);
      const newCustomDifferencesBulk = calculateDifferences(
        selectedScheduleBulk.turns[0],
        selectedScheduleBulk.turns,
        0
      );
      setRouteOrderBulk(route);
      setCustomTimeDifferencesBulk(newCustomDifferencesBulk);
      // Punto de control inicial
      const firstControlPoint = selectedScheduleBulk.turns[0].find(p => p.time !== null)?.label || "";

      // Punto de control final
      const lastControlPoint = selectedScheduleBulk.turns.at(-1)?.findLast(p => p.time !== null)?.label || "";

      // Número de vueltas
      const numLaps = selectedScheduleBulk.turns.length;

      setControlPointStartBulk(firstControlPoint); // Configurar punto de control inicial
      setControlPointEndBulk(lastControlPoint); // Configurar punto de control final
      setNumLapsBulk(numLaps);
      setTimeDifferenceBulk({ minutes: 1, seconds: 0 });

      // Actualiza los valores originales base para comparar cambios:
      setOriginalBulkValues({
        controlPointStartBulk: firstControlPoint,
        controlPointEndBulk: lastControlPoint,
        timeDifferenceBulk: { minutes: 1, seconds: 0 },
        numLapsBulk: numLaps,
      });

      setTableDataBulk(handleFillTableBulk(newCustomDifferencesBulk, route));
    }
  }, [selectedScheduleBulk]);

  useEffect(() => {
    if (schedules.length > 0) {
      if (currentScheduleIndex > 0) {
        setCurrentSchedule(schedules[currentScheduleIndex]);
      }
    }
  }, [currentScheduleIndex, schedules]);

  useEffect(() => {
    if (schedules.length > 0) {
      fillData();
    }
  }, [currentSchedule]);

  useEffect(() => {
    if (schedules.length > 0 && controlPointStart !== "" && controlPointEnd !== "") {
      setRouteOrder(currentUser.route.filter(geofence => geofence.state === 'activo').map(geofence => geofence.label));
      setCustomTimeDifferences(prev => {
        const newOrder = currentUser.route.filter(geofence => geofence.state === 'activo').map(geofence => geofence.label);
        const newDifferences = [];

        newOrder.forEach((label, index) => {
          const oldIndex = routeOrder.indexOf(label);
          // Clonamos el objeto para que no se compartan referencias
          newDifferences[index] =
            oldIndex !== -1 && prev[oldIndex] !== undefined
              ? { ...prev[oldIndex] }
              : { ...timeDifference };
        });

        return newDifferences;
      });

      handleFillTable(customTimeDifferences, currentUser.route.filter(geofence => geofence.state === 'activo').map(geofence => geofence.label));
    }
  }, [currentUser.route]);

  // useEffect(() => {
  //   if (schedules.length > 0) {
  //     setRouteOrder(currentUser.route.filter(geofence => geofence.state === 'activo').map(geofence => geofence.label));
  //     handleFillTable(customTimeDifferences, currentUser.route.filter(geofence => geofence.state === 'activo').map(geofence => geofence.label));
  //   }
  // }, [currentUser.route]);

  const moveToNext = () => {
    const nextIndex = currentScheduleIndex + 1;
    if (nextIndex < schedules.length) {
      setCurrentScheduleIndex(nextIndex);
    } else {
      onClose(); // Cierra el modal si no hay más horarios
    }
  };

  const handleCancelAll = () => {
    setTabIndex(0);
    onClose();
  };

  const handleCancel = () => {
    moveToNext();
  };

  const handleSave = () => {
    // Validar si el nombre del horario ya está asignado a otro horario
    const isNameDuplicate = userSchedules.some(
      schedule =>
        schedule._id !== currentSchedule._id && schedule.name === scheduleName
    );

    if (isNameDuplicate) {
      showAlert('No se puede guardar el horario porque el nombre del horario ya está asignado a otro horario.', 'warning');
      return; // Detener el guardado
    }

    // Validar si el vehicleId (si no es null) ya está asignado a otro horario
    let vehicleId = null;
    if (vehicle !== 'Ninguno') {
      vehicleId = devices.find(device => device.id === vehicle)?.id || null;
    }

    // Convertir horas a segundos para las vueltas
    const tableDataInSeconds = tableData.map(lap =>
      lap.map(point => {
        if (point.time === "-" || point.time === "" || !isNaN(point.time)) {
          return { ...point, time: null }; // Mantener valores vacíos como null
        }

        const [hours, minutes, seconds] = point.time.split(":").map(Number);
        return { ...point, time: hours * 3600 + minutes * 60 + seconds }; // Convertir a segundos
      })
    );

    let newScheduleName = scheduleName;

    if (scheduleName.trim() === "") {
      const existingNames = userSchedules.map(schedule => schedule.name);

      let counter = 1;
      while (existingNames.includes(`Horario ${counter}`)) {
        counter++;
      }
      newScheduleName = `Horario ${counter}`;
    }

    // Guardar el horario actualizado
    onSave({
      _id: currentSchedule._id,
      name: newScheduleName,
      userId: currentSchedule.userId,
      vehicleId,
      turns: tableDataInSeconds,
    });

    moveToNext(); // Continuar al siguiente horario
  };

  // Validación para asegurarse de que los valores no sean menores a 1
  const validateNumberInput = (setter) => (value, max) => {
    const newValue = Math.min(Math.max(1, Number(value)), max);
    setter(newValue);
  };

  const saveBulk = () => {
    // 1. Obtén valores del horario original
    const originalTurns = selectedScheduleBulk.turns || [];
    const originalRouteOrder = (originalTurns[0] || []).map(cp => cp.label);
    const originalCustomDiffs = calculateDifferences(originalTurns[0] || [], originalTurns, 0);
    const originalControlStart = originalTurns[0]?.find(p => p.time !== null)?.label || "";
    const originalControlEnd = (originalTurns.at(-1)?.findLast(p => p.time !== null)?.label) || "";
    const originalNumLaps = originalTurns.length;

    // 2. Arma lista de diferencias detectadas
    const diffs = [];

    if (JSON.stringify(customTimeDifferencesBulk) !== JSON.stringify(originalCustomDiffs)) {
      diffs.push("Diferencias entre puntos de control.");
    }
    if (JSON.stringify(routeOrderBulk) !== JSON.stringify(originalRouteOrder)) {
      diffs.push("Orden de los puntos de control.");
    }
    if (originalBulkValues.controlPointStartBulk !== originalControlStart) {
      diffs.push("Punto de control inicial.");
    }
    if (originalBulkValues.controlPointEndBulk !== originalControlEnd) {
      diffs.push("Punto de control final.");
    }
    if (originalBulkValues.numLapsBulk !== originalNumLaps) {
      diffs.push("Número de vueltas.");
    }

    // 3. Si no hay cambios: showAlert y return
    if (diffs.length === 0) {
      showAlert("No hay cambios a realizar.", "warning");
      return;
    }

    // 4. Si hay cambios: mostrar modal de confirmación
    setBulkDiff(diffs);
    setBulkConfirmOpen(true);
  };

  const getTotalSeconds = (diff) => (diff?.minutes ?? 0) * 60 + (diff?.seconds ?? 0);

  const handleFillTable = (differences = customTimeDifferences, routeOrd = routeOrder) => {
    if (!controlPointStart || !controlPointEnd || !startTime || !differences || !numLaps) {
      // alert("Por favor, complete todos los campos para llenar la tabla.");
      console.log(controlPointStart, ' - ', controlPointEnd, ' - ', startTime, ' - ', differences, ' - ', numLaps)
      showAlert("Por favor, complete todos los campos para llenar la tabla.", "warning");
      return;
    }

    let startIndex = routeOrd.indexOf(controlPointStart);
    let endIndex = routeOrd.indexOf(controlPointEnd);

    if (startIndex === -1 || endIndex === -1) {
      if (startIndex === -1) {
        startIndex = 0;
        setControlPointStart(routeOrd[0]);
      }
      if (endIndex === -1) {
        endIndex = 0;
        setControlPointEnd(routeOrd[0]);
      }
    }

    const newTableData = [];
    let currentLapTime = dayjs(startTime); // Hora inicial, ajustable

    for (let lap = 0; lap < numLaps; lap++) {
      const lapData = [];

      for (let index = 0; index < routeOrd.length; index++) {
        const label = routeOrd[index];
        const point = geofences.find((gf) => gf.label === label.replace(/\s(Ida|Vuelta)$/, ""));
        let time = "-";
        const diffObj = differences[index] || timeDifference;
        const secondsToAdd = getTotalSeconds(diffObj);

        if (numLaps === 1) {
          // Si solo hay una vuelta, asignar tiempos solo dentro del rango
          if (index >= startIndex && index <= endIndex) {
            time = currentLapTime.format("HH:mm:ss");
            currentLapTime = currentLapTime.add(secondsToAdd, "second");
          }
        } else if (lap === 0) {
          // Primera vuelta: Llenar horas desde el punto de control inicial hasta el final
          if (index >= startIndex) {
            time = currentLapTime.format("HH:mm:ss");
            currentLapTime = currentLapTime.add(secondsToAdd, "second");
          }
        } else if (lap > 0 && lap < numLaps - 1) {
          // Vueltas intermedias: Llenar todas las horas
          time = currentLapTime.format("HH:mm:ss");
          currentLapTime = currentLapTime.add(secondsToAdd, "second");
        } else if (lap === numLaps - 1) {
          // Última vuelta: Llenar horas hasta el punto de control final
          if (index <= endIndex) {
            time = currentLapTime.format("HH:mm:ss");
            currentLapTime = currentLapTime.add(secondsToAdd, "second");
          }
        }

        lapData.push({
          id: point?.id || index,
          label,
          time,
        });
      }

      newTableData.push(lapData);
    }

    setTableData(newTableData); // Actualizar la tabla
  };

  const handleFillTableBulk = (differences = customTimeDifferencesBulk, routeOrd = routeOrderBulk, isChanged = false) => {

    if (isChanged && (!controlPointStartBulk || !controlPointEndBulk || !differences || !numLapsBulk)) {
      // alert("Por favor, complete todos los campos para llenar la tabla.");
      showAlert("Datos inválidos.", "error");
      return;
    }

    let startIndex = routeOrd.indexOf(isChanged ? controlPointStartBulk : selectedScheduleBulk.turns[0].find(p => p.time !== null).label);
    let endIndex = routeOrd.indexOf(isChanged ? controlPointEndBulk : selectedScheduleBulk.turns.at(-1)?.findLast(p => p.time !== null).label);

    if (isChanged) {
      if (startIndex === -1) {
        startIndex = 0;
        setControlPointStartBulk(routeOrd[0]);
      }
      if (endIndex === -1) {
        endIndex = 0;
        setControlPointEndBulk(routeOrd[0]);
      }
    }

    if (startIndex === -1 || endIndex === -1) {
      // alert("Puntos de control inválidos.");
      showAlert("Puntos de control inválidos.", "warning");
      return;
    }

    const numLapsB = isChanged ? numLapsBulk : selectedScheduleBulk.turns.length;

    // Hora de inicio: Primer valor `time` no nulo en la primera vuelta
    const firstNonNullTime = selectedScheduleBulk.turns[0].find(p => p.time !== null)?.time || 0;
    const formattedStartTime = formatTime(firstNonNullTime);

    // Separar horas y minutos
    const [hours, minutes, seconds] = formattedStartTime.split(':').map(Number);
    const startTime = dayjs().hour(hours).minute(minutes).second(seconds);

    const newTableData = [];
    let currentLapTime = dayjs(startTime); // Hora inicial, ajustable

    for (let lap = 0; lap < numLapsB; lap++) {
      const lapData = [];

      for (let index = 0; index < routeOrd.length; index++) {
        const label = routeOrd[index];
        const point = geofences.find((gf) => gf.label === label.replace(/\s(Ida|Vuelta)$/, ""));
        let time = "-";
        const diffObj = differences[index] || timeDifferenceBulk;
        const secondsToAdd = getTotalSeconds(diffObj);

        if (numLapsB === 1) {
          // Si solo hay una vuelta, asignar tiempos solo dentro del rango
          if (index >= startIndex && index <= endIndex) {
            time = currentLapTime.format("HH:mm:ss");
            currentLapTime = currentLapTime.add(secondsToAdd, "second");
          }
        } else if (lap === 0) {
          // Primera vuelta: Llenar horas desde el punto de control inicial hasta el final
          if (index >= startIndex) {
            time = currentLapTime.format("HH:mm:ss");
            currentLapTime = currentLapTime.add(secondsToAdd, "second");
          }
        } else if (lap > 0 && lap < numLapsB - 1) {
          // Vueltas intermedias: Llenar todas las horas
          time = currentLapTime.format("HH:mm:ss");
          currentLapTime = currentLapTime.add(secondsToAdd, "second");
        } else if (lap === numLapsB - 1) {
          // Última vuelta: Llenar horas hasta el punto de control final
          if (index <= endIndex) {
            time = currentLapTime.format("HH:mm:ss");
            currentLapTime = currentLapTime.add(secondsToAdd, "second");
          }
        }

        lapData.push({
          id: point?.id || index,
          label,
          time,
        });
      }

      newTableData.push(lapData);
    }

    return newTableData;
  };

  const generateTableData = (schedule) => {

    const differences = bulkDiff.find(d => d === "Diferencias entre puntos de control.") ? customTimeDifferencesBulk : calculateDifferences(schedule.turns[0], schedule.turns, 0);
    const routeOrd = bulkDiff.find(d => d === "Orden de los puntos de control.") ? routeOrderBulk : schedule.turns[0].map(cp => cp.label);

    let startIndex = routeOrderBulk.indexOf(bulkDiff.find(d => d === "Punto de control inicial.") ? tableDataBulk[0].find(p => p.time !== '-').label : schedule.turns[0].find(p => p.time !== null).label);
    let endIndex = routeOrderBulk.indexOf(bulkDiff.find(d => d === "Punto de control final.") ? tableDataBulk.at(-1)?.findLast(p => p.time !== '-').label : schedule.turns.at(-1)?.findLast(p => p.time !== null).label);

    if (startIndex === -1 || endIndex === -1) {
      if (startIndex === -1) {
        startIndex = 0;
        setControlPointStartBulk(routeOrd[0]);
      }
      if (endIndex === -1) {
        endIndex = 0;
        setControlPointEndBulk(routeOrd[0]);
      }
    }

    const numLapsB = bulkDiff.find(d => d === "Número de vueltas.") ? numLapsBulk : schedule.turns.length;

    // Hora de inicio: Primer valor `time` no nulo en la primera vuelta
    const firstNonNullTime = schedule.turns[0].find(p => p.time !== null)?.time || 0;
    const formattedStartTime = formatTime(firstNonNullTime);

    // Separar horas y minutos
    const [hours, minutes, seconds] = formattedStartTime.split(':').map(Number);
    const startTime = dayjs().hour(hours).minute(minutes).second(seconds);

    const newTableData = [];
    let currentLapTime = dayjs(startTime); // Hora inicial, ajustable

    for (let lap = 0; lap < numLapsB; lap++) {
      const lapData = [];

      for (let index = 0; index < routeOrd.length; index++) {
        const label = routeOrd[index];
        const point = geofences.find((gf) => gf.label === label.replace(/\s(Ida|Vuelta)$/, ""));
        let time = "-";
        const diffObj = differences[index];
        const secondsToAdd = getTotalSeconds(diffObj);

        if (numLapsB === 1) {
          // Si solo hay una vuelta, asignar tiempos solo dentro del rango
          if (index >= startIndex && index <= endIndex) {
            time = currentLapTime.format("HH:mm:ss");
            currentLapTime = currentLapTime.add(secondsToAdd, "second");
          }
        } else if (lap === 0) {
          // Primera vuelta: Llenar horas desde el punto de control inicial hasta el final
          if (index >= startIndex) {
            time = currentLapTime.format("HH:mm:ss");
            currentLapTime = currentLapTime.add(secondsToAdd, "second");
          }
        } else if (lap > 0 && lap < numLapsB - 1) {
          // Vueltas intermedias: Llenar todas las horas
          time = currentLapTime.format("HH:mm:ss");
          currentLapTime = currentLapTime.add(secondsToAdd, "second");
        } else if (lap === numLapsB - 1) {
          // Última vuelta: Llenar horas hasta el punto de control final
          if (index <= endIndex) {
            time = currentLapTime.format("HH:mm:ss");
            currentLapTime = currentLapTime.add(secondsToAdd, "second");
          }
        }

        lapData.push({
          id: point?.id || index,
          label,
          time,
        });
      }

      newTableData.push(lapData);
    }

    return newTableData;
  };

  const isBulkDirty =
    controlPointStartBulk !== originalBulkValues.controlPointStartBulk ||
    controlPointEndBulk !== originalBulkValues.controlPointEndBulk ||
    (timeDifferenceBulk.minutes !== originalBulkValues.timeDifferenceBulk.minutes ||
      timeDifferenceBulk.seconds !== originalBulkValues.timeDifferenceBulk.seconds) ||
    numLapsBulk !== originalBulkValues.numLapsBulk;

  const handleDifferenceChange = (index, newDifference) => {
    const updatedDifferences = [...customTimeDifferences];
    updatedDifferences[index] = newDifference;

    setCustomTimeDifferences(updatedDifferences);

    // Recalcular la tabla y ajustar las horas
    handleFillTable(updatedDifferences);
  };

  const handleDifferenceChangeBulk = (index, newDifference) => {
    const updatedDifferences = [...customTimeDifferencesBulk];
    updatedDifferences[index] = newDifference;

    setCustomTimeDifferencesBulk(updatedDifferences);

    // Recalcular la tabla y ajustar las horas
    setTableDataBulk(handleFillTableBulk(updatedDifferences, routeOrderBulk, true));
  };

  const handleUpdateAllDifferences = (newDifference) => {
    if (!controlPointStart ||
      !controlPointEnd ||
      !startTime ||
      !newDifference ||
      typeof newDifference.minutes !== 'number' ||
      typeof newDifference.seconds !== 'number' ||
      !numLaps
    ) {
      showAlert('Por favor, complete todos los campos para llenar la tabla.', 'warning');
      return;
    }

    const isNewDifference =
      lastGeneratedTimeDifference !== null &&
      (lastGeneratedTimeDifference.minutes !== newDifference.minutes ||
        lastGeneratedTimeDifference.seconds !== newDifference.seconds);

    const updatedDifferences = isNewDifference
      ? routeOrder.map(() => ({ ...newDifference }))
      : [...customTimeDifferences];

    setCustomTimeDifferences(updatedDifferences);
    handleFillTable(updatedDifferences);
    setLastGeneratedTimeDifference({ ...newDifference });
  };

  const calculateDifferences = (turn, allTurns, index) => {
    return turn.map((point, pointIndex) => {
      // Obtener tiempos actuales y siguientes
      const currentTime = point.time ?? allTurns[index + 1]?.[pointIndex]?.time;
      const nextPoint = turn[(pointIndex + 1) % turn.length]; // Circular, último con el primero
      const nextTime =
        nextPoint?.time ?? allTurns[index + 1]?.[(pointIndex + 1) % turn.length]?.time;

      // Validar tiempos para evitar negativos
      if (currentTime !== null && nextTime !== null) {
        let diff = 0;
        if (nextTime > currentTime) {
          diff = nextTime - currentTime;
        } else {
          const newNextTime = allTurns[index + 1]?.[(pointIndex + 1) % turn.length]?.time;
          if (newNextTime) {
            diff = newNextTime - currentTime;
          }
        }
        if (diff > 0) {
          const minutes = Math.floor(diff / 60);
          const seconds = diff % 60;
          return { minutes, seconds };
        }
      }

      return { minutes: 0, seconds: 0 }; // No se puede calcular
    });
  };

  const fillData = () => {
    if (!currentSchedule?.turns?.[0]) {
      // console.error("No hay datos disponibles en turns para este horario.");
      return;
    }

    const routeOrder = currentSchedule.turns[0].map(cp => cp.label);

    setRouteOrder(routeOrder);

    // Llenar datos de la tabla, respetando el formato
    const formattedTableData = currentSchedule.turns.map((lap) =>
      routeOrder.map(label => {
        const point = lap.find(p => p.label === label) || {};
        return {
          id: point.id || null,
          label,
          time: point.time !== null ? formatTime(point.time) : "",
        };
      })
    );

    // Hora de inicio: Primer valor `time` no nulo en la primera vuelta
    const firstNonNullTime = currentSchedule.turns[0].find(p => p.time !== null)?.time || 0;
    const formattedStartTime = formatTime(firstNonNullTime);

    // Separar horas y minutos
    const [hours, minutes, seconds] = formattedStartTime.split(':').map(Number);

    // Punto de control inicial
    const firstControlPoint = currentSchedule.turns[0].find(p => p.time !== null)?.label || "";

    // Punto de control final
    const lastControlPoint = currentSchedule.turns.at(-1)?.findLast(p => p.time !== null)?.label || "";

    // Número de vueltas
    const numLaps = currentSchedule.turns.length;

    // Calcular diferencias usando la lógica extendida
    const customTimeDifferences = calculateDifferences(
      currentSchedule.turns[0],
      currentSchedule.turns,
      0
    );

    // Configurar campos del formulario
    setScheduleName(currentSchedule.name || "");
    setVehicle(currentSchedule.vehicleId !== null
      ? devices.find(device => device.id === currentSchedule.vehicleId)?.id || "Ninguno"
      : "Ninguno"
    );
    setStartTime(dayjs().hour(hours).minute(minutes).second(seconds)); // Configurar hora de inicio
    setControlPointStart(firstControlPoint); // Configurar punto de control inicial
    setControlPointEnd(lastControlPoint); // Configurar punto de control final
    setNumLaps(numLaps); // Configurar número de vueltas
    setTableData(formattedTableData);
    setCustomTimeDifferences(customTimeDifferences); // Configurar diferencias calculadas

  };

  const fillDataBulk = () => {
    if (!selectedScheduleBulk?.turns?.[0]) {
      // console.error("No hay datos disponibles en turns para este horario.");
      return;
    }

    const routeOrder = selectedScheduleBulk.turns[0].map(cp => cp.label);

    setRouteOrderBulk(routeOrder);

    // Llenar datos de la tabla, respetando el formato
    const formattedTableData = selectedScheduleBulk.turns.map((lap) =>
      routeOrder.map(label => {
        const point = lap.find(p => p.label === label) || {};
        return {
          id: point.id || null,
          label,
          time: point.time !== null ? formatTime(point.time) : "",
        };
      })
    );

    // Punto de control inicial
    const firstControlPoint = selectedScheduleBulk.turns[0].find(p => p.time !== null)?.label || "";

    // Punto de control final
    const lastControlPoint = selectedScheduleBulk.turns.at(-1)?.findLast(p => p.time !== null)?.label || "";

    // Número de vueltas
    const numLaps = selectedScheduleBulk.turns.length;

    // Calcular diferencias usando la lógica extendida
    const customTimeDifferences = calculateDifferences(
      selectedScheduleBulk.turns[0],
      selectedScheduleBulk.turns,
      0
    );

    setControlPointStartBulk(firstControlPoint); // Configurar punto de control inicial
    setControlPointEndBulk(lastControlPoint); // Configurar punto de control final
    setNumLapsBulk(numLaps); // Configurar número de vueltas
    setTimeDifferenceBulk({ minutes: 1, seconds: 0 });
    setTableDataBulk(formattedTableData);
    setCustomTimeDifferencesBulk(customTimeDifferences); // Configurar diferencias calculadas

    setOriginalBulkValues({
      controlPointStartBulk: firstControlPoint,
      controlPointEndBulk: lastControlPoint,
      timeDifferenceBulk: { minutes: 1, seconds: 0 },
      numLapsBulk: numLaps,
    });
  };

  const handleScheduleNameChange = (e) => {
    const name = e.target.value;
    setScheduleName(name);

    // Validar si el nombre del horario ya existe
    const isDuplicate = userSchedules.some(
      schedule =>
        schedule._id !== currentSchedule._id && schedule.name === name
    );

    if (isDuplicate) {
      setScheduleNameError(true);
      setErrorMessage("Horario duplicado");
    } else {
      setScheduleNameError(false);
      setErrorMessage("");
    }
  };

  const handleVehicleChange = (newVehicleId) => {
    const isAssigned = userSchedules.some(
      (schedule) => schedule.vehicleId === parseInt(newVehicleId)
    );
    if (isAssigned) {
      // Guardar cambios pendientes y mostrar el modal
      setPendingVehicleChange({ newVehicleId });
      setIsConfirmModalOpen(true);
    } else {
      setVehicle(newVehicleId);
    }
  };

  const fillMultipleTable = (differences = customTimeDifferences, startTimeParam = startTime, cpStart = controlPointStart, cpEnd = controlPointEnd) => {
    if (!cpStart || !cpEnd || !startTimeParam || !differences || !numLaps) {
      // alert("Por favor, complete todos los campos para llenar la tabla.");
      showAlert('Por favor, complete todos los campos para llenar la tabla.', 'warning');
      return;
    }

    // setShowHeaders(true);

    const startIndex = routeOrder.indexOf(cpStart);
    const endIndex = routeOrder.indexOf(cpEnd);

    if (startIndex === -1 || endIndex === -1) {
      // alert("Puntos de control inválidos.");
      showAlert('Puntos de control inválidos.', 'warning');
      return;
    }

    const newTableData = [];
    let currentLapTime = dayjs(startTimeParam);

    for (let lap = 0; lap < numLaps; lap++) {
      const lapData = [];

      for (let index = 0; index < routeOrder.length; index++) {
        const label = routeOrder[index];
        const point = geofences.find((gf) => gf.label === label.replace(/\s(Ida|Vuelta)$/, ""));
        let time = "-";
        const diffObj = differences[index] || timeDifference;
        const secondsToAdd = getTotalSeconds(diffObj);

        if (numLaps === 1) {
          if (index >= startIndex && index <= endIndex) {
            time = currentLapTime.format("HH:mm:ss");
            currentLapTime = currentLapTime.add(secondsToAdd, "second");
          }
        } else if (lap === 0) {
          if (index >= startIndex) {
            time = currentLapTime.format("HH:mm:ss");
            currentLapTime = currentLapTime.add(secondsToAdd, "second");
          }
        } else if (lap > 0 && lap < numLaps - 1) {
          time = currentLapTime.format("HH:mm:ss");
          currentLapTime = currentLapTime.add(secondsToAdd, "second");
        } else if (lap === numLaps - 1) {
          if (index <= endIndex) {
            time = currentLapTime.format("HH:mm:ss");
            currentLapTime = currentLapTime.add(secondsToAdd, "second");
          }
        }

        lapData.push({
          id: point?.id || index,
          label,
          time,
        });
      }

      newTableData.push(lapData);
    }

    return newTableData;
  };

  const handleOpenMultiScheduleModal = () => {
    if (tableData.length === 0) {
      // alert("Genere el horario correctamente antes de crear más horarios.");
      showAlert('Genere el horario correctamente antes de crear más horarios.', 'warning');
      return;
    }
    setMultiScheduleModalOpen(true);
  };

  const handleCloseMultiScheduleModal = () => setMultiScheduleModalOpen(false);

  const saveMultiSchedules = (schedules) => {
    const multiSchedules = schedules.map(schedule => {
      const lapsData = fillMultipleTable(undefined, dayjs(schedule.startTime, "HH:mm:ss", true), schedule.cpStart, schedule.cpEnd).map((lap) =>
        lap.map((point) => {
          if (point.time === "-") {
            return { ...point, time: null };
          }

          const [hours, minutes, seconds] = point.time.split(":").map(Number);
          const timeInSeconds = hours * 3600 + minutes * 60 + seconds;
          return { ...point, time: timeInSeconds };
        })
      );

      return {
        name: schedule.name,
        vehicleId: schedule.vehicleId,
        turns: lapsData,
      };
    });
    // console.log(multiSchedules);
    scheduleRegister(multiSchedules);
    moveToNext();
  }

  const saveChangesBulk = () => {
    if (bulkDiff.length === 0) {
      showAlert("No hay cambios detectados.", "error");
      setBulkConfirmOpen(false);
      return;
    }

    const multiSchedules = schedules.map(schedule => {
      const lapsData = generateTableData(schedule).map((lap) =>
        lap.map((point) => {
          if (point.time === "-") {
            return { ...point, time: null };
          }

          const [hours, minutes, seconds] = point.time.split(":").map(Number);
          const timeInSeconds = hours * 3600 + minutes * 60 + seconds;
          return { ...point, time: timeInSeconds };
        })
      );

      return {
        _id: schedule._id,
        name: schedule.name,
        userId: schedule.userId,
        turns: lapsData,
      };
    });

    const allSchedules = userSchedules.map(schedule => {
      // Busca si este horario fue modificado (existe en multiSchedules)
      const modified = multiSchedules.find(s => s._id === schedule._id);
      if (modified) {
        // Devuelve el horario original con los turns modificados
        return { ...schedule, turns: modified.turns };
      } else {
        // Devuelve el horario tal cual estaba
        return schedule;
      }
    });

    updateSchedule(allSchedules, multiSchedules, true);
    setBulkConfirmOpen(false);
    setTabIndex(0);
    onClose();
  }

  return (
    <div className='card_content new-schedule-layout' style={{ display: 'flex', flexDirection: 'column' }}>
      <Button onClick={() => setShowedLayout(0)} style={{ alignSelf: 'flex-start', fontSize: '0.7rem', alignItems: 'flex-start' }}>
        <span className="material-symbols-rounded icon" style={{ fontSize: '18px' }}>arrow_back</span>
        Volver
      </Button>
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>

        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={tabIndex} onChange={handleTabChange} >
            <Tab label="Editar Horario" sx={{
              color: 'var(--color-dark)', // Color para pestañas inactivas
              '&.Mui-selected': { color: 'var(--color-primary)' },
              fontSize: '0.7rem'
            }} />
            <Tab label="Editar Todos los horarios" sx={{
              color: 'var(--color-dark)', // Color para pestañas inactivas
              '&.Mui-selected': { color: 'var(--color-primary)' },
              fontSize: '0.7rem'
            }} />
          </Tabs>
        </Box>
        <TabPanel value={tabIndex} index={0}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', overflow: 'auto', paddingTop: '10px', height: '100%' }}>

            <div className="form_container">
              <div className="fields_container">
                <TextField
                  fullWidth
                  label="Nombre del horario"
                  variant="outlined"
                  value={scheduleName}
                  onChange={handleScheduleNameChange}
                  error={scheduleNameError} // Muestra el borde rojo si hay un error
                  helperText={scheduleNameError ? errorMessage : ""} // Muestra el mensaje de error
                  sx={{
                    '& .MuiInputLabel-root': {
                      color: 'var(--color-dark)', // Cambia el color de la label
                      fontSize: '0.8rem',
                    },
                    '& .MuiInputLabel-shrink': {
                      fontSize: '1rem', // Tamaño de la label cuando está en foco
                    },
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        borderColor: 'var(--color-dark-variant)', // Color del borde por defecto
                      },
                      '&:not(.Mui-focused):hover fieldset': {
                        borderColor: 'var(--color-dark)', // Color del borde al pasar el mouse
                      },
                    },
                    '& .MuiInputBase-input': {
                      color: 'var(--color-dark)',
                      fontSize: '0.8rem', // Tamaño del texto de entrada
                      padding: '1rem 12px'
                    },
                  }}
                />
                {/* Seleccionar vehículo */}
                <FormControl fullWidth >
                  <InputLabel id="vehicle-select-label" sx={{ color: 'var(--color-dark)' }}>Asignar vehículo</InputLabel>
                  <Select
                    labelId="vehicle-select-label"
                    value={vehicle}
                    onChange={(e) => handleVehicleChange(e.target.value)}
                    label="Asignar vehículo"
                    sx={{
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'var(--color-dark-variant)', // Color del borde por defecto
                      },
                      '&:not(.Mui-focused):hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'var(--color-dark)', // Color del borde al pasar el mouse
                      },
                      '& .MuiInputBase-input': {
                        color: 'var(--color-dark)',
                        fontSize: '0.8rem', // Tamaño del texto de entrada
                        padding: '0.85rem 12px'
                      },
                    }}
                  >
                    <MenuItem value="Ninguno" style={{ fontSize: '0.8rem' }}>Ninguno</MenuItem>
                    {devices
                      .filter((device) => device.label).sort(mixedNaturalSort)
                      .map((device, index) => (
                        <MenuItem key={index} value={device.id} style={{ fontSize: '0.8rem' }}>
                          {device.label}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <TimeField
                    label="Hora de Inicio"
                    value={startTime}
                    onChange={(newValue) => setStartTime(newValue)}
                    format="HH:mm:ss" // Configura el formato a 24 horas
                    fullWidth
                    sx={{
                      '& .MuiInputLabel-root': {
                        color: 'var(--color-dark)', // Cambia el color de la label
                      },
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                          borderColor: 'var(--color-dark-variant)', // Color del borde por defecto
                        },
                        '&:not(.Mui-focused):hover fieldset': {
                          borderColor: 'var(--color-dark)', // Color del borde al pasar el mouse
                        },
                      },
                      '& .MuiInputBase-input': {
                        fontSize: '0.8rem', // Tamaño del texto dentro del campo de entrada
                        padding: '1rem 12px', // Ajuste de padding para alinear correctamente el texto
                        color: 'var(--color-dark)', // Color del texto
                      }
                    }}
                  />
                </LocalizationProvider>
                {/* Seleccionar punto de control de inicio */}
                <FormControl fullWidth >
                  <InputLabel id="control-point-start-label" sx={{
                    color: 'var(--color-dark)',
                    fontSize: '0.8rem', // Tamaño de la etiqueta cuando NO está en foco
                    '&.MuiInputLabel-shrink': {
                      fontSize: '1rem', // Mantiene el mismo tamaño cuando está en foco
                    }
                  }}>Punto de Control Inicial</InputLabel>
                  <Select
                    labelId="control-point-start-label"
                    value={controlPointStart}
                    onChange={(e) => setControlPointStart(e.target.value)}
                    label="Punto de Control Inicial"
                    sx={{
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'var(--color-dark-variant)', // Color del borde por defecto
                      },
                      '&:not(.Mui-focused):hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'var(--color-dark)', // Color del borde al pasar el mouse
                      },
                      '& .MuiSelect-select': {
                        color: 'var(--color-dark)',
                        fontSize: '0.8rem', // Tamaño del texto dentro del `Select`
                        padding: '0.85rem 12px'
                      }
                    }}
                  >
                    {routeOrder.map((geofence, index) => (
                      <MenuItem key={index} value={geofence} style={{ fontSize: '0.8rem' }}>
                        {geofence}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {/* Seleccionar punto de control de fin */}
                <FormControl fullWidth >
                  <InputLabel id="control-point-end-label" sx={{
                    color: 'var(--color-dark)',
                    fontSize: '0.8rem', // Tamaño de la etiqueta cuando NO está en foco
                    '&.MuiInputLabel-shrink': {
                      fontSize: '1rem', // Mantiene el mismo tamaño cuando está en foco
                    }
                  }}>Punto de Control Final</InputLabel>
                  <Select
                    labelId="control-point-end-label"
                    value={controlPointEnd}
                    onChange={(e) => setControlPointEnd(e.target.value)}
                    label="Punto de Control Final"
                    sx={{
                      color: 'var(--color-dark)',
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'var(--color-dark-variant)', // Color del borde por defecto
                      },
                      '&:not(.Mui-focused):hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'var(--color-dark)', // Color del borde al pasar el mouse
                      },
                      '& .MuiSelect-select': {
                        color: 'var(--color-dark)',
                        fontSize: '0.8rem', // Tamaño del texto dentro del `Select`
                        padding: '0.85rem 12px'
                      }
                    }}
                  >
                    {routeOrder.map((geofence, index) => (
                      <MenuItem key={index} value={geofence} style={{ fontSize: '0.8rem' }}>
                        {geofence}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {/* Tiempo de diferencia */}
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <TimeField
                    fullWidth
                    label="Diferencia entre puntos (mm:ss)"
                    variant="outlined"
                    format="mm:ss"
                    value={dayjs().hour(0).minute(timeDifference?.minutes ?? 5).second(timeDifference?.seconds ?? 0)}
                    onChange={(newValue) => {
                      if (!newValue) return;
                      let minutes = newValue.minute();
                      let seconds = newValue.second();
                      let totalSeconds = minutes * 60 + seconds;
                      // Limita a 30 minutos máximo (30:00 == 1800 segundos)
                      if (totalSeconds < 60) {
                        minutes = 1;
                        seconds = 0;
                        totalSeconds = 60;
                      } else if (totalSeconds > 1800) {
                        minutes = 30;
                        seconds = 0;
                        totalSeconds = 1800;
                      }
                      setTimeDifference({ minutes, seconds });
                    }}

                    sx={{
                      '& .MuiInputLabel-root': {
                        color: 'var(--color-dark)', // Cambia el color de la label
                      },
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                          borderColor: 'var(--color-dark-variant)', // Color del borde por defecto
                        },
                        '&:not(.Mui-focused):hover fieldset': {
                          borderColor: 'var(--color-dark)', // Color del borde al pasar el mouse
                        },
                      },
                      '& .MuiInputBase-input': {
                        fontSize: '0.8rem', // Tamaño del texto dentro del campo de entrada
                        padding: '1rem 12px', // Ajuste de padding para alinear correctamente el texto
                        color: 'var(--color-dark)', // Color del texto
                      }
                    }}
                  />
                </LocalizationProvider>
                {/* Número de vueltas */}
                <TextField
                  fullWidth
                  type="number"
                  label="Número de Vueltas"
                  variant="outlined"
                  value={numLaps}
                  onChange={(e) => validateNumberInput(setNumLaps)(e.target.value, 50)}
                  slotProps={{
                    input: {
                      min: 1,
                      max: 50,
                      step: 1,
                      onClick: (event) => event.target.select(),
                    },
                  }}
                  sx={{
                    '& .MuiInputLabel-root': {
                      color: 'var(--color-dark)', // Cambia el color de la label
                    },
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        borderColor: 'var(--color-dark-variant)', // Color del borde por defecto
                      },
                      '&:not(.Mui-focused):hover fieldset': {
                        borderColor: 'var(--color-dark)', // Color del borde al pasar el mouse
                      },
                    },
                    '& .MuiInputBase-input': {
                      fontSize: '0.8rem', // Tamaño del texto dentro del campo de entrada
                      padding: '1rem 12px', // Ajuste de padding para alinear correctamente el texto
                      color: 'var(--color-dark)', // Color del texto
                    }
                  }}
                />
              </div>
              <div className="buttons_container">
                <Button
                  sx={{ fontSize: '0.7rem' }}
                  onClick={() => {
                    const route = userRoute.filter(geofence => geofence.state === 'activo').map(geofence => geofence.label);
                    const newCustomTimeDifferences = route.map((_, idx) =>
                      customTimeDifferences[idx] !== undefined
                        ? customTimeDifferences[idx]
                        : { minutes: 5, seconds: 0 }
                    );

                    setRouteOrder(route);
                    setCustomTimeDifferences(newCustomTimeDifferences);
                    handleFillTable(newCustomTimeDifferences, route);
                  }}
                >
                  Adaptar puntos de control a la ruta actual
                </Button>
                {/* Modificar orden de puntos de control */}
                <Button style={{ fontSize: '0.7rem' }} onClick={() => setOpenRouteModal(true)}>
                  Modificar Ruta
                </Button>
                {openRouteModal &&
                  <RouteModal onOpen={openRouteModal} onClose={setOpenRouteModal} userRoute={userRoute} setUserRoute={setUserRoute} userUpdate={userUpdate} currentUser={currentUser} />
                }
                {/* Rellenar tabla */}
                <Button
                  variant="contained"
                  color="primary"
                  // onClick={handleFillTable}
                  onClick={() => handleUpdateAllDifferences(timeDifference)}
                  style={{ fontSize: '0.7rem' }}
                >
                  Generar Horario
                </Button>
              </div>
            </div>
            {/* Tabla de datos */}
            <div className="table_wrapper">
              <table>
                <thead>
                  <tr>
                    {routeOrder.map((label, index) => (
                      <th key={index}>{label}</th>
                    ))}
                  </tr>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <tr>
                      {customTimeDifferences.map((difference, index) => (
                        <th key={index}>
                          <TimeField
                            value={dayjs().hour(0).minute(difference?.minutes ?? 0).second(difference?.seconds ?? 0)}
                            onChange={(newValue) => {
                              if (!newValue) return; // Previene errores si se borra
                              let minutes = newValue.minute();
                              let seconds = newValue.second();
                              let totalSeconds = minutes * 60 + seconds;
                              // Limita a 30 minutos máximo (30:00 == 1800 segundos)
                              if (totalSeconds < 60) {
                                minutes = 1;
                                seconds = 0;
                                totalSeconds = 60;
                              } else if (totalSeconds > 1800) {
                                minutes = 30;
                                seconds = 0;
                                totalSeconds = 1800;
                              }
                              handleDifferenceChange(index, { minutes, seconds });
                            }}
                            format="mm:ss"
                            fullWidth
                            variant="standard"
                            sx={{

                              backgroundColor: 'white',
                              '& .MuiInputLabel-root': {
                                color: 'var(--color-dark)',
                              },
                              '& .MuiOutlinedInput-root': {
                                padding: '0',
                                '& fieldset': {
                                  borderColor: 'var(--color-dark-variant)',
                                },
                                '&:not(.Mui-focused):hover fieldset': {
                                  borderColor: 'var(--color-dark)',
                                },
                              },
                              '& .MuiInputBase-input': {
                                fontSize: '0.7rem',
                                padding: '0.5rem 0',
                                color: 'var(--color-dark)',
                                textAlign: 'center'
                              }
                            }}
                          />
                        </th>
                      ))}
                    </tr>
                  </LocalizationProvider>
                </thead>

                <tbody>
                  {tableData.map((lap, lapIndex) => (
                    <tr key={lapIndex}>
                      {lap.map((point, pointIndex) => (
                        <td key={pointIndex}>
                          {point.time !== "-" ? point.time : ''}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <Box className="modal_bottom_container">
              <span>{currentScheduleIndex + 1} - {schedules.length}</span>
              <Box className="button_container">
                <Button
                  onClick={handleOpenMultiScheduleModal}
                  disabled={false}
                >
                  Generar varios horarios
                </Button>
                <Button onClick={handleCancelAll}>Cancelar Todo</Button>
                <Button className="cancel_button" onClick={handleCancel}>Cancelar</Button>
                <Button className="accept_button" onClick={handleSave}>Guardar</Button>
              </Box>
            </Box>
          </div>
        </TabPanel>
        <TabPanel value={tabIndex} index={1}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', overflow: 'auto', paddingTop: '10px', height: '100%' }}>
            <div className="form_container">
              <div className="fields_container">
                <FormControl fullWidth>
                  <InputLabel id="schedule-select-bulk-label" sx={{
                    color: 'var(--color-dark)',
                    fontSize: '0.8rem',
                    '&.MuiInputLabel-shrink': { fontSize: '1rem' }
                  }}>
                    Horario Seleccionado
                  </InputLabel>
                  <Select
                    labelId="schedule-select-bulk-label"
                    value={selectedScheduleBulk?._id || ""}
                    onChange={e => setSelectedScheduleBulk(schedules.find(schedule => schedule._id === e.target.value) || "")}
                    label="Horario Seleccionado"
                    sx={{
                      '& .MuiOutlinedInput-notchedOutline': { borderColor: 'var(--color-dark-variant)' },
                      '&:not(.Mui-focused):hover .MuiOutlinedInput-notchedOutline': { borderColor: 'var(--color-dark)' },
                      '& .MuiSelect-select': { color: 'var(--color-dark)', fontSize: '0.8rem', padding: '0.85rem 12px' }
                    }}
                  >
                    {schedules.map((s, idx) => (
                      <MenuItem key={s._id} value={s._id} style={{ fontSize: '0.8rem' }}>
                        {s.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                {/* Punto de control inicial */}
                <FormControl fullWidth>
                  <InputLabel id="control-point-start-label-massive" sx={{
                    color: 'var(--color-dark)',
                    fontSize: '0.8rem',
                    '&.MuiInputLabel-shrink': { fontSize: '1rem' }
                  }}>Punto de Control Inicial</InputLabel>
                  <Select
                    labelId="control-point-start-label-massive"
                    value={controlPointStartBulk}
                    onChange={(e) => setControlPointStartBulk(e.target.value)}
                    label="Punto de Control Inicial"
                    sx={{
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'var(--color-dark-variant)',
                      },
                      '&:not(.Mui-focused):hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'var(--color-dark)',
                      },
                      '& .MuiSelect-select': {
                        color: 'var(--color-dark)',
                        fontSize: '0.8rem',
                        padding: '0.6rem 12px'
                      }
                    }}
                  >
                    {routeOrderBulk.map((geofence, index) => (
                      <MenuItem key={index} value={geofence} style={{ fontSize: '0.8rem' }}>
                        {geofence}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                {/* Punto de control final */}
                <FormControl fullWidth>
                  <InputLabel id="control-point-end-label-massive" sx={{
                    color: 'var(--color-dark)',
                    fontSize: '0.8rem',
                    '&.MuiInputLabel-shrink': { fontSize: '1rem' }
                  }}>Punto de Control Final</InputLabel>
                  <Select
                    labelId="control-point-end-label-massive"
                    value={controlPointEndBulk}
                    onChange={(e) => setControlPointEndBulk(e.target.value)}
                    label="Punto de Control Final"
                    sx={{
                      color: 'var(--color-dark)',
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'var(--color-dark-variant)',
                      },
                      '&:not(.Mui-focused):hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'var(--color-dark)',
                      },
                      '& .MuiSelect-select': {
                        color: 'var(--color-dark)',
                        fontSize: '0.8rem',
                        padding: '0.85rem 12px'
                      }
                    }}
                  >
                    {routeOrderBulk.map((geofence, index) => (
                      <MenuItem key={index} value={geofence} style={{ fontSize: '0.8rem' }}>
                        {geofence}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                {/* Diferencia entre puntos */}
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <TimeField
                    fullWidth
                    label="Diferencia entre puntos (mm:ss)"
                    variant="outlined"
                    format="mm:ss"
                    value={dayjs().hour(0).minute(timeDifferenceBulk?.minutes ?? 5).second(timeDifferenceBulk?.seconds ?? 0)}
                    onChange={(newValue) => {
                      if (!newValue) return;
                      let minutes = newValue.minute();
                      let seconds = newValue.second();
                      let totalSeconds = minutes * 60 + seconds;
                      // Limita a 30 minutos máximo (30:00 == 1800 segundos)
                      if (totalSeconds < 60) {
                        minutes = 1;
                        seconds = 0;
                        totalSeconds = 60;
                      } else if (totalSeconds > 1800) {
                        minutes = 30;
                        seconds = 0;
                        totalSeconds = 1800;
                      }
                      setTimeDifferenceBulk({ minutes, seconds });
                    }}

                    sx={{
                      '& .MuiInputLabel-root': {
                        color: 'var(--color-dark)', // Cambia el color de la label
                      },
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                          borderColor: 'var(--color-dark-variant)', // Color del borde por defecto
                        },
                        '&:not(.Mui-focused):hover fieldset': {
                          borderColor: 'var(--color-dark)', // Color del borde al pasar el mouse
                        },
                      },
                      '& .MuiInputBase-input': {
                        fontSize: '0.8rem', // Tamaño del texto dentro del campo de entrada
                        padding: '1rem 12px', // Ajuste de padding para alinear correctamente el texto
                        color: 'var(--color-dark)', // Color del texto
                      }
                    }}
                  />
                </LocalizationProvider>

                {/* Número de vueltas */}
                <TextField
                  fullWidth
                  type="number"
                  label="Número de Vueltas"
                  variant="outlined"
                  value={numLapsBulk}
                  onChange={(e) => {
                    const val = Math.max(1, Math.min(50, Number(e.target.value)));
                    setNumLapsBulk(val);
                  }}
                  slotProps={{
                    htmlInput: {
                      min: 1,
                      max: 50,
                      step: 1,
                      onClick: (event) => event.target.select(),
                    },
                  }}
                  sx={{
                    '& .MuiInputLabel-root': { color: 'var(--color-dark)' },
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': { borderColor: 'var(--color-dark-variant)' },
                      '&:not(.Mui-focused):hover fieldset': { borderColor: 'var(--color-dark)' },
                    },
                    '& .MuiInputBase-input': {
                      fontSize: '0.8rem',
                      padding: '1rem 12px',
                      color: 'var(--color-dark)'
                    }
                  }}
                />
              </div>
              <div className="buttons_container">
                {/* Botón para adaptar puntos */}
                <Button
                  sx={{ fontSize: '0.7rem' }}
                  onClick={() => {
                    const route = userRoute.filter(geofence => geofence.state === 'activo').map(geofence => geofence.label);
                    const newCustomTimeDifferences = route.map((_, idx) =>
                      customTimeDifferencesBulk[idx] !== undefined
                        ? customTimeDifferencesBulk[idx]
                        : { minutes: 5, seconds: 0 }
                    );

                    setRouteOrderBulk(route);
                    setCustomTimeDifferencesBulk(newCustomTimeDifferences);
                    setTableDataBulk(handleFillTableBulk(newCustomTimeDifferences, route, !isBulkDirty ? true : false));
                    // showAlert && showAlert("Puntos de control adaptados a la ruta actual.", "success");
                  }}
                >
                  Adaptar puntos de control a la ruta actual
                </Button>
                <Button variant='contained' sx={{ fontSize: '0.7rem' }}
                  onClick={() => {
                    const isNewDifference =
                      lastGeneratedTimeDifferenceBulk !== null &&
                      (lastGeneratedTimeDifferenceBulk.minutes !== timeDifferenceBulk.minutes ||
                        lastGeneratedTimeDifferenceBulk.seconds !== timeDifferenceBulk.seconds);

                    const updatedDifferences = isNewDifference
                      ? routeOrderBulk.map(() => ({ ...timeDifferenceBulk }))
                      : [...customTimeDifferencesBulk];

                    setCustomTimeDifferencesBulk(updatedDifferences);

                    setLastGeneratedTimeDifferenceBulk({ ...timeDifferenceBulk });

                    setTableDataBulk(handleFillTableBulk(updatedDifferences, routeOrderBulk, true));
                    setOriginalBulkValues({
                      controlPointStartBulk,
                      controlPointEndBulk,
                      timeDifferenceBulk,
                      numLapsBulk,
                    });
                  }}
                  disabled={!isBulkDirty}
                >
                  Aplicar cambios
                </Button>
              </div>
            </div>
            <div className="table_wrapper">
              <table>
                <thead>
                  <tr>
                    {routeOrderBulk.map((label, index) => (
                      <th key={index}>{label}</th>
                    ))}
                  </tr>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <tr>
                      {customTimeDifferencesBulk.map((difference, index) => (
                        <th key={index}>
                          <TimeField
                            value={dayjs().hour(0).minute(difference?.minutes ?? 0).second(difference?.seconds ?? 0)}
                            onChange={(newValue) => {
                              if (!newValue) return; // Previene errores si se borra
                              let minutes = newValue.minute();
                              let seconds = newValue.second();
                              let totalSeconds = minutes * 60 + seconds;
                              // Limita a 30 minutos máximo (30:00 == 1800 segundos)
                              if (totalSeconds < 60) {
                                minutes = 1;
                                seconds = 0;
                                totalSeconds = 60;
                              } else if (totalSeconds > 1800) {
                                minutes = 30;
                                seconds = 0;
                                totalSeconds = 1800;
                              }
                              handleDifferenceChangeBulk(index, { minutes, seconds });
                            }}
                            format="mm:ss"
                            fullWidth
                            variant="standard"
                            sx={{

                              backgroundColor: 'white',
                              '& .MuiInputLabel-root': {
                                color: 'var(--color-dark)',
                              },
                              '& .MuiOutlinedInput-root': {
                                padding: '0',
                                '& fieldset': {
                                  borderColor: 'var(--color-dark-variant)',
                                },
                                '&:not(.Mui-focused):hover fieldset': {
                                  borderColor: 'var(--color-dark)',
                                },
                              },
                              '& .MuiInputBase-input': {
                                fontSize: '0.7rem',
                                padding: '0.5rem 0',
                                color: 'var(--color-dark)',
                                textAlign: 'center'
                              }
                            }}
                          />
                        </th>
                      ))}
                    </tr>
                  </LocalizationProvider>
                </thead>

                <tbody>
                  {tableDataBulk.map((lap, lapIndex) => (
                    <tr key={lapIndex}>
                      {lap.map((point, pointIndex) => (
                        <td key={pointIndex}>
                          {point.time !== "-" ? point.time : ''}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <Box className="modal_bottom_container">
              <span></span>
              <Box className="button_container">
                <Button className="cancel_button" onClick={handleCancelAll}>Cancelar</Button>
                <Button className="accept_button" onClick={saveBulk}>Guardar</Button>
              </Box>
            </Box>
          </div>
        </TabPanel>
      </div>
      <ConfirmModal title={'Confirmación'} text={`Este vehículo ya se encuentra asignado al horario "${userSchedules.find((schedule) => schedule.vehicleId === pendingVehicleChange?.newVehicleId)?.name || ''}". ¿Desea asignarlo a este horario de cualquier manera?`} isOpen={isConfirmModalOpen} onClose={setIsConfirmModalOpen}
        confirmFunction={() => {
          if (pendingVehicleChange) {
            setVehicle(pendingVehicleChange.newVehicleId);
          }
          setIsConfirmModalOpen(false);
        }} />
      <ConfirmModal
        title={'¿Está seguro de continuar?'}
        text={'Al aceptar, se aplicarán los siguientes cambios a TODOS los horarios seleccionados. ¿Desea aplicar estos cambios?'}
        isOpen={bulkConfirmOpen}
        onClose={setBulkConfirmOpen}
        confirmFunction={saveChangesBulk}
      >
        <div>
          <ul style={{ marginLeft: 24 }}>
            {bulkDiff.map((d, idx) => <li key={idx} style={{ color: 'var(--color-dark-variant)' }}>{d}</li>)}
          </ul>
        </div>
      </ConfirmModal>
      {multiScheduleModalOpen &&
        <MultiSchedulesModal
          onOpen={multiScheduleModalOpen}
          onClose={handleCloseMultiScheduleModal}
          onSave={saveMultiSchedules}
          devices={devices}
          userSchedules={userSchedules}
          routeOrder={routeOrder}
          multiScheduleCount={multiScheduleCount}
          setMultiScheduleCount={setMultiScheduleCount}
          scheduleName={scheduleName}
          setScheduleName={setScheduleName}
          controlPointStart={controlPointStart}
          controlPointEnd={controlPointEnd}
          startTime={startTime}
          showAlert={showAlert}
          isEditing={true}
        />
      }
    </div>
  )
}

export default EditSchedulesAdmin
